import { useEventReporter, useStore } from "../../../../../contexts";
import { useRedirectToProposal } from "../../../../../hooks/useCreateAgreement";
import { Send1stAgreementIcon } from "../../BusinessOnboardingWidget.icons";
import { StepLayout, ActionButton } from "../../BusinessOnboardingWidget.utils";
import styles from "./TestAgreement.module.scss";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function TestAgreement(_ref) {
  let {
    isComplete
  } = _ref;
  const {
    openCreationModal
  } = useRedirectToProposal();
  const {
    logBI
  } = useStore(store => store.actions);
  const {
    reportToGtm,
    reportToAppcues,
    reportToHeap
  } = useEventReporter();
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "testAgreement",
    title: isComplete ? 'You’ve successfully sent a test agreement!' : 'Start by sending a test agreement',
    subtitle: "Get a feel for the Anchor experience before sending it to your client. Once the test agreement is sent, you\u2019ll be able to see the approval process from your client\u2019s perspective.",
    actions: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.actionsWrapper,
        children: /*#__PURE__*/_jsx(ActionButton, {
          "data-testid": "onboarding-widget-test-agreement-btn",
          onClick: async e => {
            e.preventDefault();
            logBI(11900);
            reportToGtm('button-click', 'test-agreement-initiated');
            reportToAppcues('button-click', 'test-agreement-initiated');
            reportToHeap('testAgreement', 'click', 'test-agreement-initiated');
            await openCreationModal(undefined, {
              defaultToSampleContact: true
            });
          },
          children: isComplete ? 'Send another one' : 'Send a test agreement'
        })
      })
    }),
    icon: /*#__PURE__*/_jsx(Send1stAgreementIcon, {})
  });
}